/* eslint-disable max-len */
import React from 'react'
import { createIcon } from '@chakra-ui/icon'

const MediaLibrary = createIcon({
    viewBox: '0 0 20 16',
    displayName: 'MediaLibrary',
    path: (
        <path d="M1.66667 3.2H0V7.2H0.00833333L0 14.4C0 15.28 0.75 16 1.66667 16H16.6667V14.4H1.66667V3.2ZM18.3333 1.6H11.6667L10 0H5C4.08333 0 3.34167 0.72 3.34167 1.6L3.33333 11.2C3.33333 12.08 4.08333 12.8 5 12.8H18.3333C19.25 12.8 20 12.08 20 11.2V3.2C20 2.32 19.25 1.6 18.3333 1.6ZM5.83333 10.4L9.58333 5.6L12.5 9.208L14.5833 6.8L17.5 10.4H5.83333Z" fill="white" />
    ),
})

export default MediaLibrary